import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { onboardingSelector } from '../../../reducers/onboarding';
import { apiRequest } from '../../../APIClient';

export const useFetchAvailableGenericSensors = () => {
  const hasFetched = useSelector(
    onboardingSelector.hasFetchedAvailableGenericSensors,
  );

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!hasFetched) {
      dispatch(apiRequest.getOnboardingAvailableGenericSensors());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
};
